import React from "react";
import {
    FaUser,
} from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";
import { formatAmount } from "../../helpers";


function TransferSummary({ summaryData, onClick, setSelectedId, selectedId }) {
    //const [selectedId, setSelectedId] = useState(null);
    const summary = [
        {
            amount: '₹' + summaryData?.balance || 0,
            flatCount: summaryData?.totalFlatCount || 0,
            label: `Available Balance`,
            color: "text-black",
            icon: <FaUser size={20} className="text-blue-400" />,
            filter: 'Navigate',
        },
        {
            amount: '₹' + summaryData?.totalAmount || 0,
            flatCount: summaryData?.activeFlatCount || 0,
            label: `Total Amount`,
            color: "text-black",
            icon: <FaUser size={20} className="teal-teal-400" />,
            filter: 'All',
        },
        {
            amount: '₹' + summaryData?.successfulAmount || 0,
            flatCount: summaryData?.inactiveFlatCount || 0,
            label: `Successful`,
            color: "text-black",
            icon: <FaUser size={20} className="text-green-400" />,
            filter: 'SUCCESS',
        },
        {
            amount: '₹' + summaryData?.pendingAmount || 0,
            flatCount: summaryData?.pendingFlatCount || 0,
            label: `Pending`,
            color: "text-black",
            icon: <FaUser size={20} className="text-orange-400" />,
            filter: 'PENDING',
        },
        {
            amount: '₹' + summaryData?.failedAmount || 0,
            flatCount: summaryData?.pendingFlatCount || 0,
            label: `Failed`,
            color: "text-black",
            icon: <FaUser size={20} className="text-orange-400" />,
            filter: 'FAILED',
        },
        {
            amount: '₹' + summaryData?.reversedAmount || 0,
            flatCount: summaryData?.pendingFlatCount || 0,
            label: `Reversed`,
            color: "text-black",
            icon: <FaUser size={20} className="text-orange-400" />,
            filter: 'REVERSED',
        },
        {
            amount: '₹' + formatAmount(Number(summaryData?.totalCharges || 0) + Number(summaryData?.totalTax || 0)),
            flatCount: summaryData?.pendingFlatCount || 0,
            label: `Charges`,
            color: "text-black",
            icon: <FaUser size={20} className="text-orange-400" />,
            filter: 'All',
        },
    ];
    return (
        <Wrapper>
            <ScrollCard
                style={{
                    scrollBehavior: "smooth",
                }}
            >
                {summary.map((item, index) => (
                    <Card $selected={selectedId === index} index={index} key={index}

                        // onClick={() => {
                        //     setSelectedId(index);
                        //     onClick(item.filter);
                        // }}
                        onClick={() => {
                            if (selectedId === index) {
                                setSelectedId(null);
                                onClick("All");
                            } else {
                                setSelectedId(index);
                                onClick(item.filter);
                            }
                        }}

                    >
                        <ValueRow>
                            <Value color={item.color}>{item.amount}</Value>
                        </ValueRow>
                        <Label>
                            <span>
                                {item.label}

                                {item.flatCount > 0 && (
                                    <span className="text-xs text-gray-400">
                                        {" • "} {item.flatCount} Flats
                                    </span>
                                )}
                            </span>

                            <ArrowWrap className="arrow">
                                <Chevron />
                            </ArrowWrap>
                        </Label>
                    </Card>
                    // <Card key={index} onClick={() => onClick(item.filter)}>
                    //     <div>
                    //         <span className={`text-[18px] font-bold ${item.color}`}>
                    //             {item.amount}
                    //         </span>
                    //         <Label>
                    //             {item.label}
                    //             {item.icon}
                    //         </Label>
                    //     </div>
                    // </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}
const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;
// const Card = tw.div`min-w-[200px] p-3 rounded-md bg-white shadow-md cursor-pointer hover:shadow-sm hover:shadow-primary-color  ${({ selectedId, index }) => selectedId === index ? "shadow-sm shadow-primary-color" : ""}`;
// const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between break-words whitespace-normal w-full`;
// const Value = tw.p`
//   text-xl sm:text-2xl font-bold  
//   ${({ color }) =>
//         color}
// `;

const Card = tw.div`
  group min-w-[200px]
  rounded-lg bg-white
  p-4 cursor-pointer
  border border-gray-100
  shadow-sm
  transition-all duration-200
  hover:shadow-md hover:border-gray-200
  ${({ $selected }) =>
        $selected
            ? "border-primary-color shadow-md"
            : ""}
`;


const ValueRow = tw.div`
  flex items-baseline gap-1
`;

const Value = tw.div`
  text-xl font-semibold text-gray-900
`;

const Label = tw.div`
  flex  mt-2 text-sm text-gray-500 items-center justify-between
`;

const ArrowWrap = tw.div`
  flex items-center
  text-gray-300
  transition-all duration-200
`;

const Chevron = tw(MdOutlineChevronRight)`
  text-lg
  transform translate-x-0
  opacity-60
  group-hover:opacity-100
  group-hover:text-gray-500
  group-hover:translate-x-1
`;

export default TransferSummary;

